// Bunico: "Daha fazla göster" (planlar/2026-09-28-asama-1-kart-listeleme.md > Hız çözümü, R9/R12/R13).
// Ana görünüm yalnızca ilk parti kartı çizer. Bağlantı JS kapalıyken tüm kartlar sayfasına (?view=bunico-tumu) gider;
// JS açıkken bağlantı adresi sayfanın güncel adresinden (tüm parametreleriyle) yeniden kurulur (R14).
// JS açıkken ilk tıklamada aynı adres bu section'ın kimliğiyle (section_id) TEK istekte çekilir; ayarlar ana şablondan gelir.
// Yanıt sayfayla karşılaştırılır: toplam aynı, tekrar eden kart yok ve ilk partinin hepsi yanıtta (sıra serbest,
// A6-ARAMA-SIRA). Tutarsa sayfada olmayan kartlar yanıt sırasıyla gizli eklenir ve data-step kadar açılır; sonraki
// tıklamalar istek atmaz.
// Güncellik (R9/R13): tıklama anındaki adres ve bağlantı istek bağlamıdır. Öğe kaldırıldıysa, bağlantı ya da sayfa adresi
// değiştiyse (filtre/sıralama/geri-ileri) sonuç sessizce atılır; ekleme ve yönlendirme yapılmaz. Filtre formundaki
// değişiklik, geri/ileri, istek sürerken başka bir bağlantıya tıklama veya form gönderimi çekimi hemen iptal eder
// (normal gezinme henüz sayfayı değiştirmeden gelen eski hata, kullanıcının gittiği adresi ezmesin).
// Yalnızca güncel isteğin gerçek hatasında bağlantıya (tüm kartlar sayfası) gidilir.
// Filtre/sıralama grid HTML'ini yenilediğinde yeni öğe connectedCallback ile kendini baştan kurar.
if (!customElements.get('bn-load-more')) {
  customElements.define('bn-load-more', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.closest('#main-collection-product-grid') || this.parentElement;
      this.link = this.querySelector('a[href]');
      this.status = this.querySelector('[role="status"]');
      this.step = parseInt(this.dataset.step, 10);
      this.total = parseInt(this.dataset.total, 10);
      this.firstIds = (this.dataset.firstIds || '').split(',').filter(Boolean);
      this.loaded = false;
      this.request = null;
      // Eksik/bozuk veri alanında JS devreye girmez; bağlantı normal çalışır (tüm kartlar sayfası).
      if (!this.link || !this.dataset.sectionId || !(this.step > 0) || !(this.total > this.firstIds.length)) return;
      // R14: sunucu bağlantısı yalnız Liquid'in bildiği parametreleri taşır (arama seçenekleri options[...] okunamaz).
      // JS açıkken tam liste adresi sayfanın güncel adresinden türetilir: tüm parametreler korunur, page kaldırılır.
      // Çekim, hata yönlendirmesi ve yeni sekmede açma bu adresi kullanır.
      this.link.href = this.fullListUrl();

      this.onClick = (event) => this.handleClick(event);
      this.onFacetChange = (event) => {
        if (event.target.closest && event.target.closest('facet-filters-form')) this.cancel();
      };
      this.onPopState = () => this.cancel();
      // İstek sürerken kullanıcı başka bir bağlantıya/forma gittiyse eski isteğin hatası onun gezinmesini ezmemeli.
      this.onNavigateIntent = (event) => {
        if (event.type === 'submit') return this.cancel();
        const anchor = event.target.closest && event.target.closest('a[href]');
        if (!anchor || anchor === this.link || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        if (anchor.getAttribute('href').startsWith('#')) return;
        this.cancel();
      };
      this.grid.classList.add('bn-load-more-active');
      this.link.addEventListener('click', this.onClick);
      document.addEventListener('input', this.onFacetChange, true);
      document.addEventListener('change', this.onFacetChange, true);
      window.addEventListener('popstate', this.onPopState);
    }

    disconnectedCallback() {
      this.cancel();
      if (!this.onClick) return;
      this.link.removeEventListener('click', this.onClick);
      document.removeEventListener('input', this.onFacetChange, true);
      document.removeEventListener('change', this.onFacetChange, true);
      window.removeEventListener('popstate', this.onPopState);
    }

    handleClick(event) {
      // Yeni sekmede açma vb. tarayıcı davranışları korunur.
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      if (this.loaded) this.reveal();
      else if (!this.request) this.fetchRest();
    }

    pageAddress() {
      return window.location.pathname + window.location.search;
    }

    fullListUrl() {
      const url = new URL(window.location.href);
      url.hash = '';
      ['page', 'section_id', 'view'].forEach((key) => url.searchParams.delete(key));
      url.searchParams.set('view', 'bunico-tumu');
      return url.toString();
    }

    isCurrent(request) {
      return this.request === request && this.isConnected && this.link.href === request.href && this.pageAddress() === request.page;
    }

    cancel() {
      if (!this.request) return;
      this.request.controller.abort();
      this.release(this.request);
    }

    release(request) {
      if (this.request !== request) return;
      this.request = null;
      this.setBusy(false);
      document.removeEventListener('click', this.onNavigateIntent, true);
      document.removeEventListener('submit', this.onNavigateIntent, true);
    }

    setBusy(busy) {
      if (busy) {
        this.link.setAttribute('aria-disabled', 'true');
        this.grid.setAttribute('aria-busy', 'true');
      } else {
        this.link.removeAttribute('aria-disabled');
        this.grid.removeAttribute('aria-busy');
      }
    }

    async fetchRest() {
      const request = { href: this.link.href, page: this.pageAddress(), controller: new AbortController() };
      this.request = request;
      this.setBusy(true);
      document.addEventListener('click', this.onNavigateIntent, true);
      document.addEventListener('submit', this.onNavigateIntent, true);
      try {
        const url = new URL(request.href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: request.controller.signal, credentials: 'same-origin' });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const html = await response.text();
        if (!this.isCurrent(request)) return this.release(request);
        const cards = this.parseCards(html);
        this.append(cards);
        this.loaded = true;
        this.release(request);
        this.reveal();
      } catch (error) {
        // Eski ya da iptal edilmiş istek: yeni seçimi bozmamak için yönlendirme yok (R13).
        const current = error.name !== 'AbortError' && this.isCurrent(request);
        this.release(request);
        if (current) window.location.assign(request.href);
      }
    }

    parseCards(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const grid = doc.getElementById('main-collection-product-grid');
      if (!grid) throw new Error('grid yok');
      const cards = [...grid.querySelectorAll('.product-item[id^="product-item-"]')]
        .filter((card) => /^product-item-\d+$/.test(card.id));
      const ids = cards.map((card) => card.id.replace('product-item-', ''));
      const pageIds = [...this.grid.querySelectorAll('.product-item[id^="product-item-"]')]
        .filter((card) => /^product-item-\d+$/.test(card.id))
        .map((card) => card.id.replace('product-item-', ''));
      // Arada ürün kümesi değiştiyse (stok, toplam) parçaları birleştirmek yerine tüm kartlar sayfasına gidilir.
      // A6-ARAMA-SIRA (Cem, 1 Ekim 2026): aynı ürünler farklı sırada gelirse (Shopify arama sırası istekten isteğe
      // değişebiliyor) yerinde eklenir; sayfadaki ilk parti yerinde kalır, append sayfadakileri atlar.
      const responseIds = new Set(ids);
      if (cards.length !== this.total) throw new Error(`toplam ${cards.length} ≠ ${this.total}`);
      if (responseIds.size !== ids.length) throw new Error('yanıtta tekrar eden kart');
      if (this.firstIds.some((id, i) => pageIds[i] !== id || !responseIds.has(id))) throw new Error('ilk parti uyuşmuyor');
      return cards;
    }

    append(cards) {
      const present = new Set([...this.grid.querySelectorAll('.product-item[id^="product-item-"]')].map((card) => card.id));
      const fragment = document.createDocumentFragment();
      cards.forEach((card) => {
        if (present.has(card.id)) return;
        card.classList.add('bn-is-more');
        fragment.append(document.adoptNode(card));
      });
      this.before(fragment);
      // Tema, grid yenilemesinde form içi şablonları forma ekliyor (component-facets.js renderProductGrid); aynısı.
      this.grid.querySelectorAll('.bn-is-more template').forEach((template) => {
        template.closest('form')?.append(template.content.cloneNode(true));
      });
      // Karşılaştırma çubuğu yeni kartlardaki seçimleri bu olayla eşitler.
      document.dispatchEvent(new CustomEvent('krown:main-collection-grid:filtered', {
        bubbles: true, detail: { gridElement: document.getElementById('CollectionProductGrid') || this.grid }
      }));
    }

    hiddenItems() {
      return [...this.grid.querySelectorAll('.product-item.bn-is-more')];
    }

    reveal() {
      const next = this.hiddenItems().slice(0, this.step);
      next.forEach((item) => item.classList.remove('bn-is-more'));
      if (next.length) {
        this.status.textContent = this.dataset.statusTemplate.replace('[count]', next.length);
        const link = next[0].querySelector('a[href]:not([tabindex="-1"])');
        if (link) link.focus();
      }
      if (this.hiddenItems().length === 0) this.link.hidden = true;
    }
  });
}
